/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://7detzgflbzh7nhv6x7frtnkida.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:09b6f4cd-40e9-489d-ad93-367d5fcf107a",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_oyNbuknu3",
    "aws_user_pools_web_client_id": "3g73rnihconinq9ejqohmi57tr",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "canvas-20200513162425-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d3s2njjpk82doc.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "InfiniteCanvas-dev",
            "region": "eu-west-1"
        },
        {
            "tableName": "InfiniteCanvasTemplate-dev",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "canvas55bddcd8e288450bbecbaa68d412868f121641-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
